import { englishToNepaliNumberMapper } from '../_helper';

function Date({
  day,
  activeDate,
  selectedDate,
  noOfEventsClass,
  handleDateClick,
  language,
  dayIndex
}) {
  return (
    <li>
      <div
        className={`bgDate
          ${!day.isCurrentMonth ? 'not-in-this-month' : 'this-month-day'}
          ${day.date === activeDate && 'date-today'}
          ${day.date === selectedDate && 'date-selected'}
          ${noOfEventsClass}
          `}
        onClick={() => {
          handleDateClick(day);
        }}>
        <span>{language === 'en' ? dayIndex + 1 : englishToNepaliNumberMapper[dayIndex + 1]}</span>
      </div>
    </li>
  );
}

export default Date;
